module.exports = __webpack_public_path__ + "img/portrait-069.76841d98.jpg";